export interface Poolable {
  active: boolean;
  setActive(value: boolean): unknown;
  setVisible(value: boolean): unknown;
}

export class ObjectPool<T extends Poolable> {
  private free: T[] = [];
  private all: T[] = [];

  constructor(private factory: () => T) {}

  acquire(): T {
    let obj = this.free.pop();
    if (!obj) {
      obj = this.factory();
      this.all.push(obj);
    }
    obj.setActive(true);
    obj.setVisible(true);
    return obj;
  }

  release(obj: T): void {
    obj.setActive(false);
    obj.setVisible(false);
    this.free.push(obj);
  }

  releaseAll(): void {
    for (const obj of this.all) {
      if (obj.active) this.release(obj);
    }
  }

  forEachActive(cb: (obj: T) => void): void {
    for (const obj of this.all) {
      if (obj.active) cb(obj);
    }
  }

  stats(): { total: number; free: number; active: number } {
    const total = this.all.length;
    const free = this.free.length;
    return { total, free, active: total - free };
  }
}
